import React from 'react';
import MdiIcon from 'src/componentes/mdi-icon';
import { FormattedMessage } from 'react-intl';
import { Row, Col, UncontrolledTooltip } from 'reactstrap';
import Info from 'src/componentes/info';
import formatDateFns from 'src/utils/formatDateFns';
import {
  DownloadArquivoSistema,
  DownloadFileBucket,
} from 'src/services/downloadFileUrl';
import Avatar from 'src/componentes/avatar';
import ContentManager from 'src/componentes/content-manager';
import ViewDocument from '../ViewDocument';
import './dropzone-arquivo-exibicao-tabela.css';
import useAuth from 'src/hooks/useAuth';
import { format } from 'date-fns';

const handleDownloadArquivo = (arquivo, isFileBucket) => {
  if (isFileBucket) {
    DownloadFileBucket(arquivo.nome);
  } else if (arquivo.guid) {
    DownloadArquivoSistema(arquivo.guid);
  } else if (arquivo.id) {
    DownloadArquivoSistema(arquivo.id);
  }
};

const handleViewDocument = (arquivoNome) => {
  ContentManager.addContent(<ViewDocument fileName={arquivoNome} />);
};

const isPdfFile = (fileName) => {
  return (
    typeof fileName === 'string' && fileName.toLowerCase().endsWith('.pdf')
  );
};

const DropzoneArquivoExibicaoTabela = ({
  arquivos = [],
  onDownload,
  onDeleteFile,
  isFileBucket = false,
  disabled = false,
  isOnlyDownload = false,
}) => {
  const { user } = useAuth();
  const { currentDisplay, currentLocale } = formatDateFns(user?.idioma);
  const renderDate = (dataInfo) => {
    if (!dataInfo) return '-';
    if (typeof dataInfo === 'string') return dataInfo;

    return format(dataInfo, currentDisplay, { locale: currentLocale });
  };

  return (
    <div className="dropzone-anexo">
      <table className="dropzone-table">
        <thead>
          <tr>
            <th>
              <FormattedMessage id="nome" />
            </th>
            <th>
              <FormattedMessage id="inseridoPor" />
              <Info
                id="responsavelAnexoHint"
                className="tabela-hint"
                placement="right"
                text={<FormattedMessage id="responsavelAnexoHint" />}
              />
            </th>
            <th>
              <FormattedMessage id="data" />
              <Info
                id="dataInclusaolAnexoHint"
                className="tabela-hint"
                placement="right"
                text={<FormattedMessage id="dataInclusaolAnexoHint" />}
              />
            </th>
            <th style={{ width: '60px' }} />
          </tr>
        </thead>
        <tbody>
          {arquivos.map((arquivo, idx) => {
            const rowClass = arquivo.isNew ? 'new-row' : '';
            const isDocumentView = isPdfFile(arquivo.nome);
            return (
              <tr key={arquivo.id || idx} className={rowClass}>
                <td>{arquivo.nome ?? '-'}</td>
                <td className="text-center">
                  {arquivo.responsavelNome ? (
                    <Row className="align-items-center">
                      <Col xs="auto">
                        <Avatar
                          size={32}
                          foto={arquivo.fotoColaborador}
                          label={arquivo.responsavelNome}
                          showLabel={true}
                        />
                      </Col>
                    </Row>
                  ) : (
                    '-'
                  )}
                </td>
                <td>
                  {arquivo.dataInclusao
                    ? renderDate(arquivo.dataInclusao)
                    : '-'}
                </td>
                <td>
                  <div className="d-flex justify-content-center">
                    {isFileBucket && !arquivo.isNew && (
                      <div id={`btnViewDocument-${idx}`}>
                        <button
                          disabled={disabled || !isDocumentView}
                          type="button"
                          className="btn btn-link p-0 mr-2"
                          onClick={() => handleViewDocument(arquivo.nome)}
                        >
                          <MdiIcon icon="eye-outline" />
                        </button>
                        <UncontrolledTooltip
                          placement="bottom"
                          target={`btnViewDocument-${idx}`}
                        >
                          {isDocumentView ? (
                            <FormattedMessage id="visualizarDocumento" />
                          ) : (
                            <FormattedMessage id="formatoNaoCompativelVisualizacao" />
                          )}
                        </UncontrolledTooltip>
                      </div>
                    )}
                    {!arquivo.isNew && (
                      <button
                        disabled={disabled}
                        type="button"
                        className="btn btn-link p-0 mr-2"
                        onClick={() =>
                          handleDownloadArquivo(arquivo, isFileBucket)
                        }
                      >
                        <MdiIcon icon="download" />
                      </button>
                    )}
                    <button
                      disabled={disabled || isOnlyDownload}
                      type="button"
                      className="btn btn-link p-0"
                      onClick={() => onDeleteFile?.(arquivo)}
                    >
                      <MdiIcon icon="delete" color="red" />
                    </button>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default DropzoneArquivoExibicaoTabela;
